import { ErrorBoundary } from "@sentry/react";
import React from "react";
import blueCedarLogo from "../../assets/favicons/official-cedar-logo.png";
import "../../assets/styles/main.scss";
import "../../assets/styles/pages/login.scss";
import { ErrorMsg } from "../../components/AppMessages";
import { SignUpForm } from "../../components/Forms";
import { useAppHeight } from "../Login/subs/helpers";

const SignUp = (): JSX.Element => {
  // Login.tsx already does this on mount - this page shares its "#loginPage" wrapper/background
  // (login.scss) and its height: var(--app-height) rule, but never called this itself, so
  // --app-height stayed unset for anyone landing here first (rather than navigating from Login
  // within the same session), leaving the wrapper's height at its invalid-var fallback (auto)
  // instead of the real viewport height.
  useAppHeight();

  return (
    <div className={"pageWrapper"} id={"loginPage"}>
      <div className="dashboard" id="login_dashboard">
        <p id="IESupportMessage" />
        <div id="container">
          <div className="form_body" id="login_form_body">
            <div className="header_section">
              <img src={blueCedarLogo} alt="" />
              <span className="header_section_wordmark">CEDAR</span>
            </div>
            <ErrorBoundary fallback={<ErrorMsg class={"formError"} />}>
              <SignUpForm />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
